import arrayParser from "../arrayParser"

const cnsProcessor=(element)=>
{
let assembledElement = " a central nervous system disorder"
let sites =""
let neuroSigns=[]

if (element["Type(s) of disorder:"] !== " ")
    {
    let disorderTypes= arrayParser(element["Type(s)_of_disorder:"])
    assembledElement += ` with ${disorderTypes.toLowerCase()} symptoms`
    }

if (element["Symptomatic_side_(if_relevant):"] !=="" || (element["Site(s):"]).length > 0)
    {
    assembledElement += " affecting  "
    }

if (element["Symptomatic_side_(if_relevant):"] !== "")
    {
    assembledElement += ` ${(element["Symptomatic_side_(if_relevant):"] === "Bilateral" ? " both" : `the ${element["Symptomatic_side_(if_relevant):"].toLowerCase()}`)}`
    }

if (element["Site(s):"].length > 0)
    {
        sites = arrayParser(element["Site(s):"])
        if (element["Symptomatic_side_(if_relevant):"] !== "")
            {
            if (element["Symptomatic_side_(if_relevant):"] === "Bilateral")
                {
                sites = sites.replace("arm(s)" , "arms")
                sites = sites.replace("leg(s)", "legs")
                sites = sites.replace("head", "sides of the head")
                }
            else
                {
                sites =  sites.replace("arm(s)" , "arm")
                sites = sites.replace("leg(s)", "leg")
                sites = sites.replace("head", "side of the head")
                } 
        
            assembledElement += sites
            }
    }
    
else if (element["Symptomatic_side_(if_relevant):"] !== "")
    {
    assembledElement += ` ${(element["Symptomatic_side_(if_relevant):"] === "Bilateral" ? "sides" : "side")} of their body`
    }

if (element["Power_(affected_side):"] !== "")
    {
    neuroSigns.push(`${element["Power_(affected_side):"].toLowerCase()} power`)
    }

if (element["Tone_(affected_side):"] !== "")
    {
    neuroSigns.push(`${element["Tone_(affected_side):"].toLowerCase()} tone`)
    }

if (element["Reflexes_(affected_side):"] !== "")
    {
    neuroSigns.push(`${element["Reflexes_(affected_side):"].toLowerCase()} reflexes`)
    }

if (element["Plantar_reflex_(affected_side):"] !== "")
    {
    neuroSigns.push(`${element["Plantar_reflex_(affected_side):"].toLowerCase()} plantar reflex`)
    }

if (neuroSigns.length > 0)
    {
    let neuroSignsString = arrayParser(neuroSigns)
    assembledElement += ` with ${neuroSignsString}`
    }

if (element["Present_for_several:"] !== "")
    {
    assembledElement += `. These neurological symptoms have been present for several ${element["Present_for_several:"].toLowerCase()}`
    }

if (element["Other_description_of_condition:"] !== "")
    {
    assembledElement += `. The symptoms and findings are described as ${element["Other_description_of_condition:"]}`
    }

 
return (assembledElement)
}

export default cnsProcessor